import { FadeUp, MaskedReveal, SectionLabel } from "@/components/Motion";

export default function Contact() {
  return (
    <div className="pt-10 md:pt-16" data-testid="contact-page">
      <section className="editorial-container">
        <SectionLabel number="No. 005" label="Correspondence" />
        <div className="grid grid-cols-12 gap-x-6 mt-6">
          <h1 className="col-span-12 lg:col-span-10 font-serif text-[13vw] sm:text-[9vw] md:text-[7vw] lg:text-[6rem] leading-[1] tracking-tight text-ink pb-4">
            <MaskedReveal text="Write to us." as="span" className="block italic text-terracotta" delay={0.1} animate />
          </h1>
        </div>
        <FadeUp delay={0.6}>
          <p className="mt-8 font-serif text-xl md:text-2xl leading-[1.4] text-ink/75 max-w-2xl">
            Notes from a reader, ideas for a future edition, a small thank-you — we open every envelope
            and every email.
          </p>
        </FadeUp>
      </section>

      <section className="mt-16 editorial-container">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <FadeUp>
              <div className="overline text-ink/50 mb-3">By post</div>
              <p className="font-serif text-2xl italic text-ink leading-tight">
                The Safe Mama Editorial <br /> c/o Banyan Editorials
              </p>
              <div className="overline text-ink/50 mt-10 mb-3">By email</div>
              <a
                className="font-serif text-2xl italic text-terracotta nav-link"
                href="mailto:thesafemamaeditorial@gmail.com"
                data-testid="contact-email"
              >
                thesafemamaeditorial@gmail.com
              </a>
              <div className="overline text-ink/50 mt-10 mb-3">On Instagram</div>
              <a
                className="font-serif text-2xl italic text-ink nav-link"
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-instagram"
              >
                @thesafemamaeditorial
              </a>
            </FadeUp>
          </div>

          <div className="md:col-span-8">
            <FadeUp delay={0.15}>
              <div className="border border-ink/15 bg-cream overflow-hidden">
                <div className="flex items-center justify-between px-6 py-4 border-b border-ink/15">
                  <div className="overline text-ink/60">Reader's form</div>
                  <div className="overline text-ink/40">Powered by Tally</div>
                </div>
                <div className="relative" style={{ height: "720px" }}>
                  <iframe
                    title="The Safe Mama Editorial — Contact"
                    src={`https://tally.so/embed/${process.env.REACT_APP_TALLY_ID}?alignLeft=1&hideTitle=1&transparentBackground=1`}
                    style={{ border: 0, width: "100%", height: "100%" }}
                    data-testid="tally-iframe"
                  />
                </div>
              </div>
            </FadeUp>
          </div>
        </div>
      </section>
    </div>
  );
}
